import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';
import 'highcharts/highcharts-more';

import { bubbleChartConfiguration } from './utilities/helpers';

const BubbleChart = ({ series, ...props }) => {
  return (
    <Chart
      options={merge({}, bubbleChartConfiguration, {
        series,
        type: 'bubble',
        ...props,
      })}
      {...props}
    />
  );
};

BubbleChart.propTypes = {
  series: PropTypes.array,
};

export default BubbleChart;
